<template>
  <div
    id="back-to-top-button"
    class="static-button back-to-top-button unvisible"
    :class="`back-to-top-button--${$route.name}`"
    @click="scrollToTop"
  >
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBackToTop',
  methods: {
    scrollToTop: () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
  mounted() {
    console.log('this.$route', this.$route)
    let btn = document.querySelector('#back-to-top-button')

    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        btn.classList.remove('unvisible')
      } else {
        btn.classList.add('unvisible')
      }
      // if (
      //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      //     navigator.userAgent
      //   )
      // ) {
      //   if (window.scrollY > 400) {
      //     btn.classList.remove('unvisible')
      //   } else {
      //     btn.classList.add('unvisible')
      //   }
      // } else {
      //   btn.classList.add('unvisible')
      // }
    })
  },
}
</script>

<style>
.static-button.back-to-top-button {
  transition: all 0.25s;
  position: fixed;
  bottom: 20px;
  right: 50%;
  transform: translate(50%, 0);

  width: 45px;
  height: 45px;

  background-color: #ff4300;
  border-radius: 50%;
  z-index: 9999;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.static-button.back-to-top-button:active {
  padding-bottom: 5px;
}

.static-button.back-to-top-button * {
  position: relative;
  width: 15px;
  height: 2px;

  background-color: #fff;
}

.static-button.back-to-top-button div:first-child {
  left: 3px;
  transform: rotate(135deg);
}

.static-button.back-to-top-button div:last-child {
  left: -2.5px;
  transform: rotate(45deg);
}

.static-button.back-to-top-button.unvisible {
  right: -75px;
}
</style>
